// import { Button, Menu, MenuItem, MenuList, MenuPopover, MenuTrigger } from '@fluentui/react-components'
import { Button } from '@/components/shadcn/button'
import { useRestClient, RestSchemas } from '@/contexts/QueryProvider'
import { IconEditOutline } from '@icons/IconEditOutline'
import { useCallback } from 'react'
import AddPipelineFormV2 from '../../Forms/AddPipelineFormV2'
import { useCurrentApplication } from '../../useCurrentApplication'

type MessagesPipelinesExistingPipeline = RestSchemas['Messages.Pipeline.ExistingPipeline']

export function PipelineCardActionsMenu({ pipeline }: { pipeline: MessagesPipelinesExistingPipeline }) {
  // const [drawerOpen, setDrawerOpen] = useState<'none' | 'editPipeline' | 'deletePipeline'>('none')

  // const { applicationId } = pipeline

  const { applicationId, appName } = useCurrentApplication()

  const { getPipelineApiGetPipeline } = useRestClient()

  const invalidatePipelines = useCallback(() => {
    getPipelineApiGetPipeline.invalidateQueries({ parameters: { path: { applicationId } } })
  }, [applicationId, getPipelineApiGetPipeline])

  return (
    <AddPipelineFormV2
      selectedPipeline={pipeline}
      sheetTitle={`${appName} > Edit pipeline`}
      sheetDescription="Edit the pipeline details."
      sheetTriggerTooltip="Edit pipeline"
      mode="pipeline"
      onSubmit={invalidatePipelines}
      sheetTrigger={
        <Button variant="ghost" size="icon" className="justify-self-end">
          <IconEditOutline />
          <span className="sr-only">Edit pipeline</span>
        </Button>
      }
    />
  )

  // return (
  //   <div className="justify-self-end">
  //     <Menu>
  //       <MenuTrigger disableButtonEnhancement>
  //         <Button icon={<Navigation24Regular />} />
  //       </MenuTrigger>
  //       <MenuPopover>
  //         <MenuList>
  //           <MenuItem className="!items-center" onClick={() => setDrawerOpen('editPipeline')} icon={<Edit24Regular />}>
  //             Edit pipeline
  //           </MenuItem>
  //         </MenuList>
  //       </MenuPopover>
  //     </Menu>

  //     {/* Edit Pipeline Drawer */}
  //     <OverlayDrawerComponent
  //       open={drawerOpen === 'editPipeline'}
  //       size="medium"
  //       setOpen={(open) => setDrawerOpen(open ? 'editPipeline' : 'none')}
  //       title="Edit Pipeline"
  //       content={
  //         <AddPipelineForm
  //           mode="pipeline"
  //           applicationId={applicationId}
  //           selectedPipeline={pipeline}
  //           edit
  //           onSubmit={() => {
  //             setDrawerOpen('none')
  //             invalidatePipelines()
  //           }}
  //         />
  //       }
  //     />
  //   </div>
  // )
}
